import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import AgentModal from "./AgentModal";
import { SIDECAR_URL } from "../../services/claudeSidecar";

/**
 * Standalone test harness for the agent modal — the "island".
 *
 * Mounted at /agent-island (see App.tsx) so the Claude interface can be tested
 * end-to-end against the sidecar WITHOUT auth, redux, or the rest of the app.
 * Point repoPath at any local checkout and make sure the sidecar is running:
 *   cd claude-sidecar && npm start
 */
export default function AgentIsland() {
  const [repoPath, setRepoPath] = useState(
    "/Users/jonathanclaassens/Documents/AITests/VaingloryV1"
  );
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ p: 4, maxWidth: 720, mx: "auto" }}>
      <Typography variant="h5" gutterBottom>
        Agent modal — island test
      </Typography>
      <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Sidecar: <code>{SIDECAR_URL}</code> — start it with{" "}
          <code>cd claude-sidecar &amp;&amp; npm start</code>.
        </Typography>
        <TextField
          fullWidth
          size="small"
          label="Repo path (absolute)"
          value={repoPath}
          onChange={(e) => setRepoPath(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button variant="contained" onClick={() => setOpen(true)} disabled={!repoPath.trim()}>
          Open agent
        </Button>
      </Paper>

      <AgentModal
        open={open}
        onClose={() => setOpen(false)}
        name="Island Agent"
        wsUrl={SIDECAR_URL}
        repoPath={repoPath}
      />
    </Box>
  );
}
